
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Output,
  signal,
} from '@angular/core';
import { Files } from '../../interfaces';
import { CaseService } from '../../services';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  templateUrl: './file-upload.component.html',
  imports: [ButtonModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadComponent {
  selectedFiles = input<Files[]>();

  @Output() onRemoveFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUploadFile = new EventEmitter<any>();


  protected filesToUpload = signal<File[]>([]);
  private caseService = inject(CaseService);

  constructor() { }

  onFileSelected(event: any) {
  const fileList: FileList = event.target.files;
  if (fileList && fileList.length) {
    const file = fileList[0];
    this.filesToUpload.set([file]);
  }
}


  removePendingFile(file: any) {
    this.onRemoveFile.emit(file);
    this.filesToUpload.update((prevFiles) => prevFiles.filter((f) => f !== file));
  }


  uploadFilesHandler() {
    if (this.filesToUpload().length === 0) {
      console.error('No files to upload.');
      return;
    }
    this.onUploadFile.emit(this.filesToUpload());
    this.filesToUpload.set([])
  }


}
